import { DashboardEditorProps } from "components/ComponentType";
import DatasetScatterChartEditor from "components/dashboard/charts/dataset-scatter-chart/DatasetScatterChartEditor";
import { DatasetScatterProps } from "components/dashboard/charts/interfaces";
import React, { FC } from "react";

const ProductTemplateBubbleChartEditor: FC<DashboardEditorProps<DatasetScatterProps>> = ({
  config,
  onConfigChange,
}) => {
  return <DatasetScatterChartEditor config={config} onConfigChange={onConfigChange} bubbleChart />;
};

export default ProductTemplateBubbleChartEditor;
